import { FontNames } from '@pdf-lib/standard-fonts';
export var values = function (obj) { return Object.keys(obj).map(function (k) { return obj[k]; }); };
export var StandardFontValues = values(FontNames);
export var isStandardFont = function (input) {
    return StandardFontValues.includes(input);
};
//# sourceMappingURL=objects.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/pdf-lib/es/utils/objects.js
// module id = null
// module chunks = 